export default __webpack_public_path__ + "static/media/NEWlogo-branco.2375bedf.png";